import React, { Component } from "react";
import { connect } from "react-redux";
//IMPORT COMPONENT
import Menu   from "../Components/component_Menu";
import Loader from "../Components/component_Loader";
import ErrorMessage from "../Components/component_MsgError";
import GoToLogin    from "../Components/component_GoToLogin";
import InputIcon    from "../Components/component_IconInput";
import FilterChip   from "../Components/component_FilterChips";
import BuyVersion   from "../Components/component_BuyVersion";
import SGButtonsBar from "../Components/component_SGButtonsBar";
//COMPONENTI MATERIAL UI
import Popover, { PopoverAnimationVertical } from "material-ui/Popover";
import { Grid, Row, Col }                    from 'react-material-responsive-grid';
import MenuItem                              from "material-ui/MenuItem";
import { RadioButton, RadioButtonGroup }     from "material-ui/RadioButton";
import RaisedButton                          from "material-ui/RaisedButton";
import Toggle                                from 'material-ui/Toggle';
import Dialog                                from 'material-ui/Dialog';
import SelectField                           from "material-ui/SelectField";
import DatePicker                            from "material-ui/DatePicker";
import TextField                             from "material-ui/TextField";
import { Table, TableHeader, TableHeaderColumn, TableBody, TableRowColumn, TableRow, TableFooter } from "material-ui/Table";
//ICON
import IconArrowUp   from "material-ui/svg-icons/navigation/arrow-drop-up";
import IconArrowDown from "material-ui/svg-icons/navigation/arrow-drop-down";
import IconFilter    from "material-ui/svg-icons/content/filter-list";
import IconEdit      from "material-ui/svg-icons/editor/mode-edit";
import IconAdd       from "material-ui/svg-icons/content/add";
import IconDelete    from "material-ui/svg-icons/action/delete";
import IconShow      from "material-ui/svg-icons/image/remove-red-eye";
import IconRefresh   from "material-ui/svg-icons/navigation/refresh";
import IconGrid      from "material-ui/svg-icons/image/grid-on";
//ACTION
import {
  getTabelleList,
  orderListaTabelle,
  setTabella
} from "../Actions/Action_ServiceRequest_Tabelle";
import { getHoldingList } from "../Actions/Action_ServiceRequest_Holding";
import { getUserInfo }    from "../Actions/Action_Authentication";
//Utils
import { checkUserLanguage } from "../Utils/Check_Value";
import * as ROLES from "../Utils/Roles_Types.js";
import * as STYLES from "../Utils/Styles.js";
import { LABEL_Required, LABEL_NoResult, LABEL_Close, LABEL_Cancel, LABEL_Confirm, LABEL_DIALOG_DELETE_Body, LABEL_Save, LABEL_OrderBy, LABEL_Yes, LABEL_No, LABEL_DIALOG_TableNew, LABEL_DIALOG_TableModify, LABEL_Table,
         LABEL_Choose_Holding, LABEL_Delete, LABEL_PAGE_CustomTables, LABEL_Enter_Name, LABEL_Enter_Description, LABEL_Name, LABEL_Description, LABEL_Deleted} from "../Utils/Strings/Labels";
import createBrowserHistory from "history/createBrowserHistory";
import ConfirmDialog from "../Components/component_ConfirmDialog";
let history = createBrowserHistory();

var TIMER = null;

const styles = {
  propContainer: {
    width    : 200,
    overflow : "hidden",
    margin   : "20px auto 0"
  },
  filterDialog : {
    width    : '100%',
    maxWidth : 'none'
  },
  filterRow : {
    marginBottom : '20px'
  },
  selectField : {
    color : "red"
  }
};

const USERINFO = JSON.parse(localStorage.getItem(ROLES.USERINFO_KEY));
const USERIDHOLDING = USERINFO == null ? null : USERINFO.Holding ? USERINFO.Holding.ID : null;
const USERLANGUAGE  = checkUserLanguage(USERINFO);
const CANUSEPAGE    = !(!!USERINFO) ? false :  !(USERINFO.Role.ID === ROLES.ACCOUNT_FREE_ID || USERINFO.Role.ID === ROLES.ACCOUNT_PRO_ID);

const emptyTabellaModel = {
  Nome : null, 
  Descrizione : null, 
  Holding : {
          ID   : USERINFO == null ? null: USERINFO.Holding == null ? null : USERINFO.Holding.ID,
          Nome : USERINFO == null ? null: USERINFO.Holding == null ? null : USERINFO.Holding.Nome ,
  },
  Cancellata: false
}

class Tabelle extends Component {
  constructor(props) {
    super(props);

    this.state = {
      //Table
      fixedHeader         : true,
      fixedFooter         : true,
      stripedRows         : false,
      showRowHover        : true,
      selectable          : true,
      multiSelectable     : false,
      enableSelectAll     : false,
      deselectOnClickaway : false,
      showCheckboxes      : false,
      height              : "700px",
      selectedList        : [],
      selectedObj         : {},
      //Ordinamento
      ordinaPer  : null,
      //Filter
      filter : {
        Nome         : null ,
        Descrizione  : null ,
        Cancellata   : false ,
        IDHolding    : USERINFO == null ? null: USERINFO.Holding == null ? null : USERINFO.Holding.ID //Non puo essere inserito dall'utene
      },
      filterHolding : {
        ID : null,
        Nome : null,
        Descrizione : null,
        DataInizioScadenza : null,
        DataFineScadenza : null
      },
      //Modal per la visualizzazione del dettaglio
      showDetails : {
        opened: false
      },
      showAddModify : {
        opened: false,
        data : JSON.parse(JSON.stringify(emptyTabellaModel))
      },
      showAddCampo : {
        opened : false
      },
      filterChipsList : []
    };
  }

  isSelectedRow      = index => this.state.selectedList.indexOf(index) !== -1;
  handleRowSelection = row   => this.setState({ selectedList : row , selectedObj : this.props.tabelleList[row]})

  setTimerForText = () => {
    if(TIMER != null)
      clearTimeout(TIMER);
    TIMER = setTimeout(() => {
      this.props.dispatch(getTabelleList(this.state.filter));
    }, 500);
  }

  handleChangeHolding = (event, index, value) => {
    var filter = this.state.filter;
    filter.IDHolding = value;
    this.setState( { filter : filter } );
    this.props.dispatch(getTabelleList(this.state.filter));
  }

  //Per intercettare il cambio di filtri testuali
  handleOnFilterTextChange = (value, position, label) => {
    var filterChips = this.state.filterChipsList;
    var filter = this.state.filter;
    filter[position] = value;
    filterChips[position] = {position : position, value : value, label : label };
    this.setTimerForText();
    this.setState({ filter : filter});
  };

  handleOpenAddModify = () => {
    var showAddModify = this.state.showAddModify;
    showAddModify.opened = true;
    if(this.state.selectedList.length == 1){
      showAddModify.data = JSON.parse(JSON.stringify(this.props.tabelleList[this.state.selectedList[0]]));
    }else{
      showAddModify.data = JSON.parse(JSON.stringify(emptyTabellaModel));
      if(showAddModify.data.Holding.ID == null ) showAddModify.data.Holding.ID = this.state.filter.IDHolding;
    }
    this.setState({showAddModify : showAddModify});
  }
  handleCloseAddModify = () => {
    var showAddModify = this.state.showAddModify;
    showAddModify.opened = false;
    this.setState( { showAddModify : showAddModify } );
  }
  handleCloseAddModifyWithSave = () => {
    //Controllo i campi
    var flag = true;
    var showAddModify = this.state.showAddModify;
    if(showAddModify.data.Nome == null || showAddModify.data.Nome == ""){
      showAddModify.data.msgErrorNome = LABEL_Required[USERLANGUAGE];
      flag = false;
    }else showAddModify.data.msgErrorNome = "";

    if(flag){
      showAddModify.opened = false;
      this.props.dispatch(setTabella(showAddModify.data));//mando al servizio i dati
      setTimeout( ()=> this.props.dispatch(getTabelleList(this.state.filter)) , 150);
    }else this.setState( { showAddModify : showAddModify } );
  }
  handleOnChangeAddModifyText = (value, position) => {
    var showAddModify = this.state.showAddModify;
    if(value == null || value.trim() == ""){
      showAddModify.data["msgError"+position] = LABEL_Required[USERLANGUAGE];
    }else showAddModify.data["msgError"+position] = "";
    showAddModify.data[position] = value;
    this.setState( { showAddModify : showAddModify } );
  }

  handleDeleteButton = () => this.setState({showDeleteDialog: true})

  _deleteRow = () =>{
    if(this.state.selectedList[0] > this.props.tabelleList.length){
      this.setState({selectedList : []});
      return;
    }
    var item = this.props.tabelleList[this.state.selectedList[0]];
        item.Cancellata = true;
    var newState = {
      showDeleteDialog : false, //Chiudo la dialog
    }
    if (this.state.selectedList[0] == this.props.tabelleList.length -1) // se era l'ultimo
       newState["selectedList"] = [];
    this.setState(newState);
    this.props.dispatch(setTabella(item));
    setTimeout(() => this.props.dispatch(getTabelleList(this.state.filter)), 150);
  }

  handleOrderChange = (event, index, value) => (this.state.ordinaPer = value) && this.props.dispatch(orderListaTabelle(this.props.tabelleList, value))

  componentDidMount = () => {
    if(!CANUSEPAGE) return;
    this.props.dispatch(getUserInfo());
    if(this.state.filter.IDHolding === null){
      this.props.dispatch(getHoldingList(this.state.filterHolding));
    }else{
      this.props.dispatch(getTabelleList(this.state.filter));
    }
  }

  //PER AGGIUNGERE UN CAMPO
  handleOpenAddCampo = () => {
    var url = "/campi?ID="+this.props.tabelleList[this.state.selectedList[0]].IDMaster+"&Nome="+this.props.tabelleList[this.state.selectedList[0]].Nome+"&IDH="+this.state.filter.IDHolding;
    history.push(url); history.go(url);
  }

  onDeleteChips = chip => {
    var filterChips = this.state.filterChipsList;
    var filter = this.state.filter;
    filter[chip.position] = null;
    filterChips[chip.position] = null;
    this.setTimerForText();
    this.setState({ filter : filter, filterChipsList : filterChips});
  }

  render() {
    var modifyPermission = USERINFO != null && USERINFO.Role.ID != ROLES.OPERATOR_ID;

    if(this.props.toRefreshOnRender)
      this.props.dispatch(getTabelleList(this.state.filter));
    
    //Tasti per la dialog aggiungi/modifica
    const addModifyDialogAction = [
      <RaisedButton
        label={LABEL_Cancel[USERLANGUAGE]}
        primary={false}
        onClick={this.handleCloseAddModify}
      />,
      <RaisedButton
        label={LABEL_Save[USERLANGUAGE]}
        primary={true}
        onClick={this.handleCloseAddModifyWithSave}
      />
    ];

    const addCampoDialogAction = [
      <RaisedButton
        label={LABEL_Cancel[USERLANGUAGE]}
        primary={false}
        onClick={this.handleCloseAddCampo}
      />,
      <RaisedButton
        label={LABEL_Save[USERLANGUAGE]}
        primary={true}
        onClick={this.handleCloseAddCampoWithSave}
      />
    ];


    var buttonBarList = [];
    if(modifyPermission){
      buttonBarList = [
        { //AGGIUNGI
          icon     : <IconAdd />, 
          onClick  : this.handleOpenAddModify,
          disabled : this.state.selectedList.length > 0 ,
        },
        { //MODIFICA
          icon     : <IconEdit />, 
          onClick  : this.handleOpenAddModify,
          disabled : this.state.selectedList.length !== 1,
        },
        { //ELIMINA
          icon     : <IconDelete />, 
          onClick  : this.handleDeleteButton,
          disabled : this.state.selectedList.length < 1,
        }
      ]
    }
    buttonBarList.push({ //VISUALIZZA DETTAGLIO
      icon:<IconGrid />, 
      onClick  : this.handleOpenAddCampo,
      disabled : this.state.selectedList.length !== 1
    });
    buttonBarList.push({ //REFRESH
      icon     : <IconRefresh />, 
      onClick  : () => this.props.dispatch(getTabelleList(this.state.filter))
    });


    /*{ //AGGIUNGI
                    USERINFO.Role.ID != ROLES.OPERATOR_ID &&
                    <Col sm12={1}>
                      <RaisedButton 
                      className="button-table" 
                      icon={<IconAdd />} 
                      onClick={this.handleOpenAddModify}
                      disabled={this.state.selectedList.length !== 0}/>
                    </Col>
                  }
                  { //MODIFICA
                    USERINFO.Role.ID != ROLES.OPERATOR_ID &&
                    <Col sm12={1}>
                      <RaisedButton 
                      className="button-table" 
                      icon={<IconEdit />} 
                      onClick={this.handleOpenAddModify}
                      disabled={this.state.selectedList.length !== 1 }/>
                    </Col>
                  }
                  { //ELIMINA
                    USERINFO.Role.ID != ROLES.OPERATOR_ID &&
                    <Col sm12={1}>
                      <RaisedButton 
                      className="button-table" 
                      icon={<IconDelete />} 
                      onClick={this.handleDeleteButton}
                      disabled={this.state.selectedList.length < 1 }/>
                    </Col>
                  }
                  { //VISUALIZZA DETTAGLIO
                    <Col sm12={1}>
                      <RaisedButton 
                      className ="button-table" 
                      icon      ={<IconGrid />} 
                      onClick   ={this.handleOpenAddCampo}
                      disabled  ={this.state.selectedList.length !== 1}/>
                    </Col>
                  }
                  <Col sm12={1}>
                    <RaisedButton 
                     className="button-table" 
                     icon={<IconRefresh />} 
                     onClick={() => this.props.dispatch(getTabelleList(this.state.filter))}/>
                  </Col>*/


    return <div>
        <Menu dispatch={this.props.dispatch} pageName={LABEL_PAGE_CustomTables[USERLANGUAGE]} Language={USERLANGUAGE}/>
        <Loader isFetching={this.props.isFetching}/>
        <ErrorMessage message={this.props.errorMessage} />
        <GoToLogin isAuthenticated = {this.props.isAuthenticated}/>
          <BuyVersion 
            visible={!CANUSEPAGE}
            Language={USERLANGUAGE}/>
        <div className="my-body">
            { USERIDHOLDING == null &&
              <SelectField
                  floatingLabelText={LABEL_Choose_Holding[USERLANGUAGE]}
                  value={this.state.filter.IDHolding}
                  onChange={this.handleChangeHolding}>
                    {  this.props.holdingList && this.props.holdingList.map( holding => <MenuItem key={holding.ID} value={holding.ID} primaryText={holding.Nome}/>  ) }
              </SelectField>
            }
          { this.state.filter.IDHolding != null &&
              <div>
            <Grid>
              <Row style={styles.filterRow}>
                <Col xs4={4} sm12={4} lg12={4} xl12={4}>
                    <InputIcon 
                        icon = {<IconFilter/>} 
                        className="input-label"
                        onChange          = { event => this.handleOnFilterTextChange(event.target.value, "Nome") }
                        hintText          = {LABEL_Enter_Name[USERLANGUAGE]}
                        floatingLabelText = {LABEL_Name[USERLANGUAGE]}
                        value             = {this.state.filter.Nome == null ? "" : this.state.filter.Nome}/>
                </Col>
                <Col xs4={4} sm12={4} lg12={4} xl12={4}>
                    <InputIcon 
                        icon = {<IconFilter/>} 
                        className="input-label"
                        onChange          = { event => this.handleOnFilterTextChange(event.target.value, "Descrizione") }
                        hintText          = {LABEL_Enter_Description[USERLANGUAGE]}
                        floatingLabelText = {LABEL_Description[USERLANGUAGE]}
                        value             = {this.state.filter.Descrizione == null ? "" : this.state.filter.Descrizione}/>
                </Col>
                <Col xs4={4} sm12={4} lg12={4} xl12={4}>
                  <SelectField
                      hintStyle = {styles.selectField}
                      floatingLabelText={LABEL_OrderBy[USERLANGUAGE]}
                      value={this.state.ordinaPer}
                      onChange={this.handleOrderChange}
                    >
                      <MenuItem value={"Nome"}             primaryText={LABEL_Name[USERLANGUAGE]}         rightIcon={<IconArrowUp />}/>
                      <MenuItem value={"NomeDESC"}         primaryText={LABEL_Name[USERLANGUAGE]}         rightIcon={<IconArrowDown />}/>
                      <MenuItem value={"Descrizione"}      primaryText={LABEL_Description[USERLANGUAGE]}  rightIcon={<IconArrowUp />}/>
                      <MenuItem value={"DescrizioneDESC"}  primaryText={LABEL_Description[USERLANGUAGE]}  rightIcon={<IconArrowDown />}/>
                      <MenuItem value={"Cancellata"}       primaryText={LABEL_Deleted[USERLANGUAGE]}   rightIcon={<IconArrowUp />}/>
                      <MenuItem value={"CancellataDESC"}   primaryText={LABEL_Deleted[USERLANGUAGE]}   rightIcon={<IconArrowDown />}/>
                    </SelectField>
                </Col>
              </Row>
              {USERINFO != null && <Row>
                      <SGButtonsBar list={buttonBarList}/>
                  </Row>}
            </Grid>
            
            <Table
                  className       = "shadow"
                  height          = { (window.innerHeight - 500) + "px" }
                  fixedHeader     = { this.state.fixedHeader}
                  fixedFooter     = { this.state.fixedFooter}
                  selectable      = { this.state.selectable}
                  multiSelectable = { this.state.multiSelectable}
                  onRowSelection  = { this.handleRowSelection}
                  >

                <TableHeader
                    displaySelectAll  = { this.state.showCheckboxes  }
                    adjustForCheckbox = { this.state.showCheckboxes  }
                    enableSelectAll   = { this.state.enableSelectAll }>
                      <TableRow>
                        <TableHeaderColumn style = { { width : "40%" } } tooltip = "" > { LABEL_Name[USERLANGUAGE] + " " + LABEL_Table[USERLANGUAGE] } </TableHeaderColumn>
                        <TableHeaderColumn style = { { width : "50%" } } tooltip = "" > { LABEL_Description[USERLANGUAGE]              } </TableHeaderColumn>
                        <TableHeaderColumn style = { { width : "10%" } } tooltip = "" > { LABEL_Deleted[USERLANGUAGE]                  } </TableHeaderColumn>
                      </TableRow>
                  </TableHeader>
                  <TableBody
                      displayRowCheckbox  = {this.state.showCheckboxes}
                      deselectOnClickaway = {this.state.deselectOnClickaway}
                      showRowHover        = {this.state.showRowHover}
                      stripedRows         = {this.state.stripedRows}
                    >
                      { this.props.tabelleList.map( (row, index) => (
                        <TableRow key={index} selected={this.isSelectedRow(index)}>
                          <TableRowColumn style={{width: "40%"}} > { row.Nome }        </TableRowColumn>
                          <TableRowColumn style={{width: "50%"}} > { row.Descrizione } </TableRowColumn>
                          <TableRowColumn style={{width: "10%"}} > { row.Cancellata ? LABEL_Yes[USERLANGUAGE] : LABEL_No[USERLANGUAGE] }  </TableRowColumn>
                        </TableRow>
                        ))
                      }
                      { this.props.tabelleList.length == 0 &&
                        <TableRow selectable={false} hoverable={false} hovered={false} selectable={false} striped={false}>
                          <TableRowColumn><center>{LABEL_NoResult[USERLANGUAGE]}</center></TableRowColumn>
                        </TableRow>
                      }
                    </TableBody>
                </Table>
              </div>
            }   

              <Dialog
                title={this.state.selectedList.length == 0 ? LABEL_DIALOG_TableNew[USERLANGUAGE] : LABEL_DIALOG_TableModify[USERLANGUAGE]}
                actions={addModifyDialogAction}
                modal={true}
                contentStyle={styles.filterDialog}
                open={this.state.showAddModify.opened || false}
              >
                <Grid>
                  <Row>
                    <Col xs4 = {1}></Col>
                    <Col xs4={2}>
                      <TextField className="input-label"
                        onChange          ={event => this.handleOnChangeAddModifyText(event.target.value, "Nome")}
                        hintText          = {LABEL_Enter_Name[USERLANGUAGE]}
                        floatingLabelText = {LABEL_Name[USERLANGUAGE]}
                        errorText={this.state.showAddModify.data.msgErrorNome}
                        fullWidth={true}
                        value={ this.state.showAddModify.data.Nome == null  ? "" : this.state.showAddModify.data.Nome }/>
                    </Col>
                    <Col xs4 = {1}></Col>
                  </Row>
                  <Row>
                    <Col xs4 = {1}></Col>
                    <Col xs4={2}>
                      <TextField className="input-label"
                        onChange={event => this.handleOnChangeAddModifyText(event.target.value, "Descrizione")}
                        hintText={LABEL_Enter_Description[USERLANGUAGE]}
                        floatingLabelText={LABEL_Description[USERLANGUAGE]}
                        errorText={this.state.showAddModify.data.msgErrorDescrizione}
                        value={ this.state.showAddModify.data.Descrizione == null  ? "" : this.state.showAddModify.data.Descrizione }
                        fullWidth={true}
                        multiLine={true}
                        rows={2}
                        rowsMax={5}
                        />
                    </Col>
                    <Col xs4={1}></Col>
                  </Row>
                  </Grid>
              </Dialog>

              <ConfirmDialog 
                title        = { LABEL_Delete[USERLANGUAGE] + " " + LABEL_Table[USERLANGUAGE] + ": "+ (this.state.selectedObj && this.state.selectedObj.Nome) }
                opened       = { this.state.showDeleteDialog}
                confirmLabel = { LABEL_Confirm[USERLANGUAGE]}
                cancelLabel  = { LABEL_Cancel[USERLANGUAGE]}
                onCancel     = { () => this.setState({showDeleteDialog: false}) }
                body         = {LABEL_DIALOG_DELETE_Body[USERLANGUAGE] + "" + (this.state.selectedObj && this.state.selectedObj.Nome)}
                onConfirm    = { this._deleteRow }/>
          </div>
      </div>
  }
}

function mapStateToProps(state) {
  const { tabellaReducer } = state;
  const { isFetching, isAuthenticated, tabelleList, toRefreshOnRender, errorMessage, holdingList } = tabellaReducer;
  return {
    isFetching,
    tabelleList,
    isAuthenticated,
    toRefreshOnRender,
    errorMessage,
    holdingList
  };
}

export default connect(mapStateToProps)(Tabelle);


// WEBPACK FOOTER //
// ./src/Containers/Tabelle.js